import { DeliveryAssetsComponent } from "../../delivery-assets/delivery-assets.component";
import { CustomHeaderComponent } from "../../components/custom-header/custom-header.component";
import { DeliveryAssetsLoaderService } from "../../delivery-assets/service/delivery-assets-loader.service";

export const DELIVERY_ASSETS_ROUTES= [
	{
		path: 'delivery-assets',
		component: DeliveryAssetsComponent,
		canActivate: [DeliveryAssetsLoaderService],
		data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: ''
			}
		},
	},
];
